export interface JwtClaims {
  sub: string;
  email?: string;
  tenantId: string | null;
  roles: string[];
  caps: string[];
  exp?: number;
}

function base64UrlDecode(segment: string): string {
  const b64 = segment.replace(/-/g, '+').replace(/_/g, '/');
  const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
  const binary = atob(padded);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

function toStringArray(v: unknown): string[] {
  if (Array.isArray(v)) return v.filter((x): x is string => typeof x === 'string');
  if (typeof v === 'string' && v.length > 0) return [v];
  return [];
}

/** Decodes (does not verify — the API is the authority) the claims of a platform JWT. */
export function decodeJwt(token: string): JwtClaims | null {
  const parts = token.split('.');
  if (parts.length < 2 || !parts[1]) return null;
  try {
    const raw = JSON.parse(base64UrlDecode(parts[1])) as Record<string, unknown>;
    const tenant = raw['tenantId'];
    return {
      sub: typeof raw['sub'] === 'string' ? raw['sub'] : '',
      email: typeof raw['email'] === 'string' ? raw['email'] : undefined,
      tenantId: typeof tenant === 'string' && tenant.length > 0 ? tenant : null,
      roles: toStringArray(raw['roles'] ?? raw['role']),
      caps: toStringArray(raw['caps']),
      exp: typeof raw['exp'] === 'number' ? raw['exp'] : undefined,
    };
  } catch {
    return null;
  }
}
